interface SetCookieOptions {
  secure?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
}

/**
 * Set a browser cookie. Local to rentalcover-shared (rather than
 * @whitelabel/helpers) so the auth-cookie security attributes (RCC-5231) live in
 * a single published package, with no version coupling to the generic helper.
 *
 * If no expiry is given (null), the cookie expires with the session.
 */
export const setCookie = (
  name: string,
  value: string,
  expiryDays: Date | null,
  path = '/',
  options: SetCookieOptions = {},
): void => {
  const attributes = [`${name}=${value}`];

  if (expiryDays !== null) {
    attributes.push(`expires=${expiryDays.toUTCString()}`);
  }

  attributes.push(`path=${path}`);

  if (options.sameSite) {
    attributes.push(`SameSite=${options.sameSite}`);
  }

  if (options.secure) {
    attributes.push('Secure');
  }

  document.cookie = attributes.join(';');
};
